import React from 'react';

import {Colors, Text} from '@optimaxdev/design-system';
import {CloudinaryImage} from '@optimaxdev/utils';
import classnames from 'classnames';
import {useSelector, useDispatch} from 'react-redux';

import {ACCESSORIES_TABS} from 'constants/accessory';

import {changeSelectedTab} from '../../../../store/reducers/accessories/accessories';
import {getAccessoriesAvailableTabs, getAccessoriesActiveTab} from '../../../../store/selectors';

import casesImg from './img/cases.png';
import chainsImg from './img/chains.png';
import essentialsImg from './img/essentials.png';
import wipesImg from './img/wipes.png';

import s from './accessoriesTabs.scss';

const tabCollections: Record<ACCESSORIES_TABS, {image: string; title: string}> = {
    [ACCESSORIES_TABS.CASES]: {
        image: casesImg,
        title: ACCESSORIES_TABS.CASES,
    },
    [ACCESSORIES_TABS.CHAINS]: {
        image: chainsImg,
        title: ACCESSORIES_TABS.CHAINS,
    },
    [ACCESSORIES_TABS.ESSENTIALS]: {
        image: essentialsImg,
        title: ACCESSORIES_TABS.ESSENTIALS,
    },
    [ACCESSORIES_TABS.WIPES]: {
        image: wipesImg,
        title: ACCESSORIES_TABS.WIPES,
    },
};

/**
 * AccessoriesTabs
 */
export const AccessoriesTabs = () => {
    const activeTab = useSelector(getAccessoriesActiveTab);
    const tabs = useSelector(getAccessoriesAvailableTabs);
    const dispatch = useDispatch();

    const handleTabChange = (tab: ACCESSORIES_TABS) => {
        dispatch(changeSelectedTab(tab));
    };

    return (
        <div className={s.container}>
            {tabs.map(tab => (
                <button
                    className={classnames(s.tab, {[s.active]: tab === activeTab})}
                    key={tab}
                    onClick={() => handleTabChange(tab)}
                    type="button"
                >
                    <CloudinaryImage
                        alt={tab}
                        className={s.img}
                        device="desktop"
                        src={tabCollections[tab].image}
                        width={36}
                    />
                    <Text color={Colors.limedSpruce} margin="0 16px 0 0" size="14px" medium>
                        {tabCollections[tab].title}
                    </Text>
                </button>
            ))}
        </div>
    );
};
